var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.923828,
    width: 72.6601,
    height: 72.6601,
    rx: 36.3301,
    fill: "#7A7A7A",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0596 28.4784C55.0596 28.8757 55.0596 29.2731 55.0596 29.6137C55.0596 41.3642 46.0906 54.9312 29.7421 54.9312C24.6899 54.9312 20.0351 53.4553 16.0615 50.9576C16.7427 51.0144 17.4807 51.0711 18.1619 51.0711C22.3058 51.0711 26.1658 49.652 29.2312 47.2678C25.3143 47.2111 22.0219 44.5998 20.9434 41.0804C21.511 41.1939 22.0219 41.2507 22.6463 41.2507C23.4411 41.2507 24.2358 41.1371 24.9737 40.9101C20.8866 40.1153 17.8213 36.5391 17.8213 32.2249C17.8213 32.1681 17.8213 32.1681 17.8213 32.1114C19.0133 32.7926 20.3757 33.1899 21.8516 33.2467C19.4675 31.6573 17.878 28.9325 17.878 25.8104C17.878 24.1642 18.3322 22.6315 19.0701 21.3259C23.4411 26.7186 30.0259 30.2381 37.4054 30.6355C37.2351 30.011 37.1784 29.2731 37.1784 28.5919C37.1784 23.6533 41.152 19.6797 46.0906 19.6797C48.645 19.6797 50.9724 20.7582 52.5619 22.4612C54.6054 22.0638 56.4787 21.3259 58.2384 20.3041C57.5573 22.4044 56.1381 24.1074 54.3216 25.2427C56.1381 25.0157 57.8411 24.5615 59.4305 23.8236C58.2952 25.6401 56.8193 27.2295 55.0596 28.4784Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.db681355a7d325cbf22c9f719b065ef5.svg";
export { ForwardRef as ReactComponent };